export * from './IconStrikethrough';
